import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, message, Card } from 'antd';
import logo from 'assets/images/logo.png';
// actions
import { loginAction as login } from 'redux/actions/auth';

const Signin = () => {
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();
    const authUser = useSelector((state) => state.auth.authUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (authUser) {
            if (authUser.role === 1) navigate('/dashboard');
            else navigate('/students');
        }
    }, [authUser]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            await dispatch(login(data));
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-signin mt-121">
            <img className="logo" src={logo} alt="" />
            <h3 style={{ color: '#CA3D45' }}>{t('welcome')}</h3>
            <Card className="card-signin">
                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item name="email" label={t('email')}>
                        <Input placeholder={t('input_id')} />
                    </Form.Item>
                    <Form.Item name="password" label={t('password')}>
                        <Input.Password placeholder={t('input_password')} />
                    </Form.Item>
                    <Button className="authentication-btn mb-24" type="primary" htmlType="submit" loading={loading}>
                        {t('login')}
                    </Button>
                </Form>
            </Card>
            <Link to={'/forgot-password'}>{t('forgot')}</Link>
        </div>
    );
};

export default Signin;
